import React from 'react';
import './styles.scss';

const LoaderHeader = () => (
  <div className="headerLoader">
    <span className="nameLoader" />
    <span className="arrowLoader" />
  </div>
);

const LoaderCommonFilters = () => (
  <div className="loaderFilters">
    <LoaderHeader />
    <div className="loaderCommonFilters">
      <div className="loaderFilterListLeft">
        <span className="checkBoxLoader" />
        <span className="loaderText40" />
      </div>
      <span className="loaderDigitText" />
    </div>
    <div className="loaderCommonFilters">
      <div className="loaderFilterListLeft">
        <span className="checkBoxLoader" />
        <span className="loaderText60" />
      </div>
      <span className="loaderDigitText" />
    </div>
    <div className="loaderCommonFilters">
      <div className="loaderFilterListLeft">
        <span className="checkBoxLoader" />
        <span className="loaderText80" />
      </div>
      <span className="loaderDigitText" />
    </div>
    <div className="loaderCommonFilters">
      <div className="loaderFilterListLeft">
        <span className="checkBoxLoader" />
        <span className="loaderText100" />
      </div>
      <span className="loaderDigitText" />
    </div>
    <div className="loaderMore" />
  </div>
);

const LoaderCommonFiltersWithSearch = () => (
  <div className="loaderFilters">
    <LoaderHeader />
    <div className="loaderSearchSection">
      <span className="loaderSearchBox" />
    </div>
    <div className="loaderCommonFilters">
      <div className="loaderFilterListLeft">
        <span className="checkBoxLoader" />
        <span className="loaderText40" />
      </div>
      <span className="loaderDigitText" />
    </div>
    <div className="loaderCommonFilters">
      <div className="loaderFilterListLeft">
        <span className="checkBoxLoader" />
        <span className="loaderText60" />
      </div>
      <span className="loaderDigitText" />
    </div>
    <div className="loaderCommonFilters">
      <div className="loaderFilterListLeft">
        <span className="checkBoxLoader" />
        <span className="loaderText80" />
      </div>
      <span className="loaderDigitText" />
    </div>
    <div className="loaderCommonFilters">
      <div className="loaderFilterListLeft">
        <span className="checkBoxLoader" />
        <span className="loaderText100" />
      </div>
      <span className="loaderDigitText" />
    </div>
    <div className="loaderMore" />
  </div>
);

const LoaderCommonFiltersSlider = () => (
  <div className="loaderFilters">
    <LoaderHeader />
    <div>
      <span className="loaderSlider">
        <span className="loaderCircle" />
        <span className="loaderSlide" />
        <span className="loaderCircle" />
      </span>
      <span className="loaderTextSection">
        <span className="loaderText" />
        <span className="loaderText" />
      </span>
    </div>
    <div className="loaderCommonFilters">
      <div className="loaderFilterListLeft">
        <span className="checkBoxLoader" />
        <span className="loaderText40" />
      </div>
      <span className="loaderDigitText" />
    </div>
    <div className="loaderCommonFilters">
      <div className="loaderFilterListLeft">
        <span className="checkBoxLoader" />
        <span className="loaderText60" />
      </div>
      <span className="loaderDigitText" />
    </div>
    <div className="loaderCommonFilters">
      <div className="loaderFilterListLeft">
        <span className="checkBoxLoader" />
        <span className="loaderText80" />
      </div>
      <span className="loaderDigitText" />
    </div>
    <div className="loaderCommonFilters">
      <div className="loaderFilterListLeft">
        <span className="checkBoxLoader" />
        <span className="loaderText100" />
      </div>
      <span className="loaderDigitText" />
    </div>
    <div className="loaderMore" />
  </div>
);

const LoaderHotelCategory = () => (
  <div className="loaderHotelCategory">
    <LoaderHeader />
    <div className="categoryWrapper">
      <span className="loaderCategoryRating">
        <span className="loaderIcon" />
      </span>
      <span className="loaderCategoryRating">
        <span className="loaderIcon" />
      </span>
      <span className="loaderCategoryRating">
        <span className="loaderIcon" />
      </span>
      <span className="loaderCategoryRating">
        <span className="loaderIcon" />
      </span>
    </div>
  </div>
);

const FiltersLoadingState = () => (
  <>
    <LoaderCommonFilters />
    <LoaderCommonFiltersSlider />
    <LoaderCommonFiltersSlider />
    <LoaderHotelCategory />
    <LoaderCommonFilters />
    <LoaderCommonFiltersWithSearch />
  </>
);

export default FiltersLoadingState;
